<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Installment Summary Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="section"
                        return-object
                        :items="section_list"
                        item-text="name"
                        @change="getStd()"
                        label="Select Section"
                        outlined
                        persistent-hint
                        hint="Please select section"
                    />
                </v-col>
                <v-col sm="2" v-if="section">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" item-value="id" :items="std_div_list" item-text="standard" label="Standard" outlined persistent-hint hint="Please Select Standard " />
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && section && status">
                    <v-btn class="mt-6 button" @click="onload()">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
            <v-row dense>
        <v-col cols="12" sm="6" md="6" v-if="transport_fee_detailed_list != ''">
          <v-btn
            rounded
            color="success"
            outlined
            @click="fnExcelReport('my-table-id', 'TransportDetailedReport')"
            :loading="loader"
            ><v-icon color="success">mdi-export</v-icon>Export</v-btn
          >
        </v-col>
      </v-row>
            <v-col cols="12" sm="12" md="12" v-if="transport_fee_detailed_list != ''">
                <div id="my-table-id">
                    <v-simple-table v-if="transport_fee_detailed_list!=''" dense class="elevation-1">
                        <thead>
                            <tr>
                                <td class="">Sr. No.</td>
                                <td class="">Standard</td>
                                <td class="">No Of Students Taken Transport Facility</td>
                                <td class="">Strength</td>
                                <td class="">Total Fee {{ ay }}</td>
                                <td class="">Total Collected</td>
                                <td class="">Balance {{ ay }}</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(l, index) in transport_fee_detailed_list" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ l.standard }}</td>
                                <td>{{ l.transport_applied_count }}</td>
                                <td>{{ l.strength }}</td>
                                <td>{{ l.all_total_amount }}</td>
                                <td>{{ l.all_total_paid }}</td>
                                <td>{{ l.all_total_remaining }}</td>
                            </tr>
                            <tr>
                                <td colspan="3"></td>
                                <td>{{ total_strength }}</td>
                                <td>{{ total_collection }}</td>
                                <td>{{ total_amount_paid }}</td>
                                <td>{{ total_amount_remaining }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                overlay: false,
                search: null,
                ay: null,
                installment_details: [],
                dialog: false,
                std_id: null,
                sel_std_data: null,
                std_div_list: null,
                ay_std_div_list: null,
                sel_ay_data: null,
                ay_id: null,
                total_strength: [],
                total_collection: [],
                total_amount_paid: [],
                total_amount_remaining: [],
                section_list: null,
                section: null,
                show: false,
                transport_fee_detailed_list: [],
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
            };
        },
        watch: {
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        methods: {
            fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStd() {
                // this.std_div_list = ["All"];
                // this.sel_std_data = "All";
                // this.std_div_list = null;
                // this.sel_std_data = null;
                // this.std_div_list = this.section.section_std_list;
                // this.std_div_list.unshift("All");
                // this.sel_std_data = this.std_div_list[0];
                // if (this.std_div_list.length == 0) {
                //     alert("No standard found!!!");
                //     this.std_div_list = null;
                // }    
                
                  if (!this.section) {
                    this.std_div_list = [];
                    this.sel_std_data = null;
                    return;
                }
                if (this.section.id === 'all') {
                    let allStandards = [];

                    this.section_list.forEach(sec => {
                        if (sec.section_std_list && sec.section_std_list.length) {
                            allStandards = allStandards.concat(sec.section_std_list);
                        }
                    });

                    this.std_div_list = [
                        { id: 'all', standard: 'All' },
                        ...allStandards
                    ];

                    this.sel_std_data = 'all';
                    return;
                }

                this.std_div_list = this.section.section_std_list || [];

                if (this.std_div_list.length === 0) {
                    alert("No standard found!!!");
                    this.sel_std_data = null;
                    return;
                }
                this.std_div_list.unshift({ id: 'all', standard: 'All' });
                this.sel_std_data = 'all';           
            },
            async onload() {
                // localStorage.setItem("setay", this.sel_ay_data.ay_id);
                // localStorage.setItem("setsection", this.section.id);
                // localStorage.setItem("setstatus", this.status);
                //this.show = true;
                    this.overlay = true;
                    let sectionPayload = this.section && this.section.id !== 'all'
                            ? this.section.id
                            : null;

                    let stdPayload = null;

                    if (this.sel_std_data && this.sel_std_data !== 'all') {
                        if (Array.isArray(this.sel_std_data)) {
                            stdPayload = this.sel_std_data.filter(id => id !== 'all');
                        } else {
                            stdPayload = this.sel_std_data;
                        }
                    }

                const data = {
                    // ay: this.sel_ay_data.ay_id,
                    // section: this.section.id,
                    // status: this.status,
                    // std: this.sel_std_data,
                    ay: this.sel_ay_data.ay_id,
                    section: sectionPayload,
                    status: this.status,
                    std: stdPayload
                };
                try {
                    const res = await axios.post("/ZealExamination/transportfeeDetailedReport", data);
                    if (res.data.flag == "YES") {
                        this.transport_fee_detailed_list = res.data.transport_fee_detailed_list;
                        this.ay = res.data.ay;
                        this.total_strength = res.data.total_strength;
                        this.total_collection = res.data.total_collection;
                        this.total_amount_paid = res.data.total_amount_paid;
                        this.total_amount_remaining = res.data.total_amount_remaining;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                }
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            main() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.section_list = res.data.section_std_list;

                        this.section_list = [
                            { id: 'all', name: 'All' },
                            ...(res.data.section_std_list || [])
                        ];
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.main();
        },
    };
</script>
<style scoped>
    .text-color {
        font-weight: bold;
        color: red;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
